import { render, staticRenderFns } from "./BatchSetInfoModal.vue?vue&type=template&id=38650d7e&scoped=true"
import script from "./BatchSetInfoModal.vue?vue&type=script&lang=js"
export * from "./BatchSetInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38650d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38650d7e')) {
      api.createRecord('38650d7e', component.options)
    } else {
      api.reload('38650d7e', component.options)
    }
    module.hot.accept("./BatchSetInfoModal.vue?vue&type=template&id=38650d7e&scoped=true", function () {
      api.rerender('38650d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/BatchSetInfoModal.vue"
export default component.exports